var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(`background-image: url('${_vm.background}')`)},[_c('router-view'),(_vm.$store.state.user)?_c('search'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }